import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MobbsignComponent } from './mobbsign/mobbsign.component';
import { WelcomeComponent } from './welcome/welcome.component';
import { UploadDocumentComponent } from './upload-document/upload-document.component';
import { authGuard } from './auth/auth.guard';

const routes: Routes = [
  { path: '', component: WelcomeComponent },
  { path: 'welcome', component: WelcomeComponent },
  { path: 'mobbsign/:document-id', component: MobbsignComponent, canActivate: [authGuard] },
  { path: 'upload-document', component: UploadDocumentComponent, canActivate: [authGuard] },
  { path: '**', component: WelcomeComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
